import '../../../../src/components/forms/neb-form-look-up-appointment';
import '../../../../src/components/misc/neb-icon';
import '../../../../src/components/pages/online-booking/neb-page-guest-appointments';
import '../../../../src/components/pages/online-booking/neb-page-practice-info';
import '../../../../src/components/pages/online-booking/neb-page-landing';
import '../../../neb-dialog/neb-banner-controller';
import '../../../neb-lit-components/src/components/global-loading/neb-global-loading-indicator';
import '../../../neb-lit-components/src/components/login/neb-forgot-password';
import '../../../neb-lit-components/src/components/neb-button';
import '../../../neb-lit-components/src/components/neb-tab-old';
import '../../../neb-lit-components/src/components/neb-tabs-old';
import '../../../neb-lit-components/src/components/online-booking/neb-booking-login-controller';
import '../../../neb-login/neb-timeout';
import '../../../neb-location/neb-map';
import './appointment/neb-booking-appointment-page';
import '../../../../src/components/pages/online-booking/neb-booking-walk-in-appointment-page';
import './my-appointments/neb-my-appointments';
import './my-payments/neb-my-payments';
import './neb-booking-appointment-creator';
import './review-confirm/neb-page-create-account';
import './user-nav/neb-user';

import { configure as configurePopupStack, popPopup } from '@neb/popup';
import { matchRouteSwitch } from '@neb/router';
import { LitElement, html, css } from 'lit';

import { fetchOnlinePatient } from '../../../../src/api-clients/booking/booking-patient';
import { fetchPublic } from '../../../../src/api-clients/practice-logo';
import { setRumTenant, setRumUser } from '../../../../src/library/datadog';
import { navigate } from '../../../../src/store';
import {
  getBookingAccountInviteById,
  matchBookingAccounts,
} from '../../../neb-api-client/src/booking-account-invite-api-client';
import { getOnlinePaymentMerchantAccount } from '../../../neb-api-client/src/payments/merchant-accounts-api-client';
import { resendPatientUserInvitationByEmail } from '../../../neb-api-client/src/permissions-api-client';
import { TITLES } from '../../../neb-popup';
import { fetchProviderAvailability } from '../../../neb-provider/neb-provider-availability-state';
import { fetchProviders } from '../../../neb-provider/neb-provider-state';
import { renewBookingSession } from '../../../neb-redux/actions/booking-session-actions';
import { store, connect } from '../../../neb-redux/neb-redux-store';
import {
  CSS_COLOR_HIGHLIGHT,
  CSS_COLOR_WHITE,
  CSS_FONT_SIZE_BODY,
  CSS_SPACING,
} from '../../../neb-styles/neb-variables';
import { init, signOut } from '../../../neb-utils/cognito-util';
import { REGISTRY_API_URL, CORE_API_URL } from '../../../neb-utils/env';
import { getLocalSession, performLogout } from '../../../neb-utils/session';
import { newAppointment, resetBooking } from '../store/booking/bookingAction';
import { fetchOnlineBookingLazy } from '../store/online-booking/neb-online-booking-state';
import { fetchPracticeInfo } from '../store/practiceInfo/practiceInfoAction';
import { fetchServices } from '../store/services/servicesAction';

import { getBookingWalkInOverridesV2 } from './util/enable-booking-util';
import { validateBookingAccountInvite } from './util/validate-booking-account-invite-util';

export const ELEMENTS = {
  aboutTab: { id: 'about-tab' },
  appointmentLookUpForm: { id: 'form-look-up-appointments' },
  appointmentTab: { id: 'appointment-tab' },
  bannerController: { id: 'message-dialog' },
  bookingAppointmentCreator: { id: 'booking-appointment-creator' },
  bookingAppointmentPage: { id: 'booking-appointment-page' },
  bookingWalkInAppointmentPage: { id: 'booking-walk-in-appointment-page' },
  checkInButton: { id: 'button-check-in' },
  contentPage: { id: 'page-content' },
  createAccountPage: { id: 'page-create-account' },
  forgotPasswordForm: { id: 'forgot-password-form' },
  globalLoadingOverlay: { id: 'global-loading-overlay' },
  guestAppointmentsPage: { id: 'page-guest-appointments' },
  landingPage: { id: 'page-landing' },
  loginController: { id: 'login-controller' },
  logo: { id: 'company-logo' },
  myAppointments: { id: 'appointments' },
  myPayments: { id: 'payments' },
  practiceInfoPage: { id: 'page-practice-info' },
  practiceInformation: { id: 'practice-info' },
  tenantBio: { id: 'tenant-bio' },
  tenantName: { id: 'tenant-name' },
  user: { id: 'user' },
  walkInAppointmentCreator: { id: 'walk-in-appointment-creator' },
  timer: { id: 'timer' },
};

configurePopupStack(store);

const BOOKING_PAGES = {
  CREATE_ACCOUNT: 'create-account',
  LOGIN: 'login',
  FORGOT_PASSWORD: 'forgot-password',
};

class NebBookingApp extends connect(store)(LitElement) {
  static get properties() {
    return {
      __route: String,
      __tenantShortName: String,
      __tenantId: String,
      __providers: Array,
      __numPopups: Number,
      __redirectHash: String,
      __user: Object,
      __practiceLogoSrc: String,
      __enableBooking: Boolean,
      __enableWalkIn: Boolean,
      __enableSelfCheckIn: Boolean,
      __selfCheckInInterval: Number,
      __selfCheckInRedirectDelay: Number,
      __showMyPayments: Boolean,
      __merchantAccount: Object,
      __linkedPatient: Object,
      __selfCheckInMethod: String,
      __selfCheckInPin: String,
      __bookingAccountInviteId: String,
      __emailFromInvite: String,
      __redirectFrom: String,

      layout: {
        type: String,
        reflect: true,
      },
      selectedTab: String,
      tenantPracticeInfo: Object,
    };
  }

  static get styles() {
    return css`
      :host {
        display: flex;
        flex-direction: column;
        height: 100%;
      }

      .header {
        display: flex;
        flex: 0 0 auto;
        padding-top: ${CSS_SPACING};
        padding-bottom: 5px;
        color: ${CSS_COLOR_WHITE};
        background-color: #313c4e;
      }

      :host([layout='small']) .header {
        display: flex;
        flex-direction: column-reverse;
      }

      :host([layout='small']) .page {
        margin: 0 30px;
      }

      .user {
        flex: 1;
      }

      :host([layout='small']) .user {
        padding-bottom: 40px;
      }

      .clinic-name {
        margin: ${CSS_SPACING} 0;
        font-size: 32px;
        margin-left: 70px;
        padding-left: 27px;
        flex: 2;
      }

      :host([layout='medium']) .clinic-name {
        margin-left: 40px;
      }

      :host([layout='small']) .clinic-name {
        margin-left: 0;
      }

      .main-container {
        margin: 30px 70px;
        display: flex;
        flex-direction: column;
        flex: 1 0 auto;
      }

      .login-change-password {
        margin: 0 24px;
      }

      @media (min-width: 1360px) {
        .main-container {
          margin: 30px auto;
          max-width: 1200px;
          width: 100%;
        }

        .clinic-name {
          margin-left: calc((100vw - 1200px) / 2);
        }
      }

      :host([layout='medium']) .main-container {
        margin: 30px 40px;
      }

      :host([layout='small']) .main-container {
        margin: 30px 0;
      }

      .content-container {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-gap: 50px;
        height: 100%;
      }

      :host([layout='small']) .content-container {
        min-height: calc(100vh - 236px);
      }

      :host([layout='small']) .appointment-container {
        grid-column: 1 / span 3;
      }

      .appointment-container {
        grid-column: 1 / span 2;
        position: relative;
      }

      .footer-container {
        height: 120px;
        display: flex;
        flex: 0 0 auto;
        background-color: #313c4e;
        padding: 0 80px;
        color: ${CSS_COLOR_WHITE};
        justify-content: flex-end;
      }

      :host([layout='small']) .footer-container {
        position: static;
        background-repeat: no-repeat;
        background-size: cover;
        padding-right: 0;
      }

      .footer-logo {
        display: flex;
        align-items: center;
      }

      :host([layout='small']) .footer-logo {
        padding-right: ${CSS_SPACING};
      }

      .about-container {
        flex: 1;
      }

      :host([layout='medium']) .about-container {
        padding: 0 0 27px 32px;
      }

      :host([layout='small']) .about-container {
        grid-column: 1 / span 3;
      }

      #nebulaIcon {
        fill: transparent;
        stroke: ${CSS_COLOR_HIGHLIGHT};
        width: 90px;
        height: 32px;
        margin: 0 5px 0 10px;
      }

      #nebula {
        font-size: 16px;
      }

      :host([layout='small']) .extra-spacing {
        display: flex;
        margin-left: 29px;
      }

      .tabs-container {
        display: none;
        max-width: 255px;
        color: ${CSS_COLOR_WHITE};
        margin-bottom: ${CSS_SPACING};
      }

      :host([layout='small']) .tabs-container {
        display: block;
      }

      .about-texts {
        margin-bottom: 30px;
        font-size: ${CSS_FONT_SIZE_BODY};
      }

      .location {
        display: flex;
        flex-direction: column;
      }

      .tenant-name {
        cursor: pointer;
      }

      .global-loading-overlay {
        position: absolute;
        z-index: 20;
      }
    `;
  }

  constructor() {
    super();

    this.__initHandlers();
    this.__initState();
  }

  __initState() {
    this.__fetchingPracticeInfo = false;
    this.__numPopups = 0;
    this.__navItems = this.__genNavItems();
    this.__providers = [];
    this.__redirectHash = '';
    this.__route = '';
    this.__tenantShortName = '';
    this.__user = {};
    this.__practiceLogoSrc = '';
    this.__enableBooking = false;
    this.__enableWalkIn = false;
    this.__enableSelfCheckIn = true;
    this.__showMyPayments = false;
    this.__merchantAccount = {};
    this.__linkedPatient = {};
    this.__selfCheckInMethod = '';
    this.__selfCheckInInterval = 12;
    this.__selfCheckInRedirectDelay = null;
    this.__bookingAccountInviteId = '';
    this.__emailFromInvite = '';
    this.__redirectFrom = '';

    this.layout = '';
    this.selectedTab = 'appointment';
    this.tenantPracticeInfo = {
      address: {},
    };
  }

  __initHandlers() {
    this.__handlers = {
      navigate: ({ route }) => {
        const routeWithHash = `#${route}`;

        if (this.__route !== routeWithHash) {
          navigate(routeWithHash);
        }
      },

      navigateToCreateAccount: () => this.__navigateToCreateAccount(),

      navigateToMyAppointments: () =>
        this.__handlers.navigate({ route: '/my-appointments' }),

      navigateToMyPayments: () => this.__navigateToMyPayments(),

      navigateToForgotPassword: opts => this.__navigateToForgotPassword(opts),

      navigateToRoot: () => {
        this.__handlers.navigate({ route: '/' });

        if (this.layout === 'small') {
          this.__handlers.tabChanged('appointment');
        }

        store.dispatch(newAppointment({}));
      },

      navigateToLogin: redirectHash => {
        if (redirectHash) this.__redirectHash = redirectHash;

        this.__navigateToLogin();

        if (this.layout === 'small') {
          this.__handlers.tabChanged('appointment');
        }
      },

      navigateToGuestAppointments: ({
        firstName,
        lastName,
        dateOfBirth,
        pin,
      }) => {
        if (pin) {
          this.__selfCheckInPin = pin;
          this.__handlers.navigate({ route: '/guest-appointments' });
        } else {
          this.__handlers.navigate({
            route: `/guest-appointments?firstName=${firstName}&lastName=${lastName}&dateOfBirth=${dateOfBirth}`,
          });
        }
      },

      resetOnLogout: async () => {
        const localSession = getLocalSession();
        await performLogout();

        await signOut(localSession);
        store.dispatch(resetBooking());

        this.__reload();
      },

      tabChanged: selected => {
        this.selectedTab = selected;
      },

      login: async (opts = {}) => {
        const { bookingAccountId, bookingAccountInviteId, redirectTo } = opts;

        await this.__matchAccounts({
          bookingAccountId,
          email: this.__user.clientId,
          bookingAccountInviteId,
          redirectTo,
        });

        if (redirectTo) {
          return this.__handleRedirect(redirectTo);
        }

        if (this.__redirectHash) {
          const shouldNavigateToConfirm =
            this.__user && this.__redirectHash === '#/schedule/login';

          const hash = shouldNavigateToConfirm
            ? '#/schedule/confirm'
            : this.__redirectHash;

          this.__redirectHash = '';

          return this.__handlers.navigate({ route: hash.replace('#', '') });
        }

        return this.__handlers.navigateToRoot();
      },

      passwordChanged: (email, pass, opts) => this.__navigateToLogin(opts),
      passwordResent: async (email, opts) => {
        await resendPatientUserInvitationByEmail(email);

        return this.__navigateToLogin(opts);
      },

      clearPin: () => {
        this.__selfCheckInPin = '';
      },

      cancelForgotPassword: opts => this.__navigateToLogin(opts),
    };
  }

  async __handleRedirect(redirectTo = '') {
    if (redirectTo === 'my-payments') {
      const { patient } = await fetchOnlinePatient();
      this.__linkedPatient = patient || {};
      this.__showMyPayments = !!this.__linkedPatient?.patientId;

      return this.__navigateToMyPayments();
    }

    return this.__navigateTo('/');
  }

  async __matchAccounts({ bookingAccountId, email, bookingAccountInviteId }) {
    try {
      if (bookingAccountInviteId) {
        const invite = await getBookingAccountInviteById(
          bookingAccountInviteId,
        );

        if (invite?.active && email && bookingAccountId) {
          await matchBookingAccounts(bookingAccountInviteId, {
            bookingAccountId,
            email,
          });

          this.__emailFromInvite = '';
        }
      }

      if (
        [BOOKING_PAGES.CREATE_ACCOUNT].includes(this.redirectFrom) &&
        this.__emailFromInvite
      ) {
        this.__emailFromInvite = '';
      }
    } catch (error) {
      console.error(error);
    }
  }

  __navigateToCreateAccount() {
    return this.__navigateTo(`/${BOOKING_PAGES.CREATE_ACCOUNT}`);
  }

  __navigateToForgotPassword(opts = {}) {
    return this.__navigateTo(`/${BOOKING_PAGES.FORGOT_PASSWORD}`, opts);
  }

  __navigateToLogin(opts = {}) {
    return this.__navigateTo(`/${BOOKING_PAGES.LOGIN}`, opts);
  }

  __navigateToMyPayments() {
    return this.__navigateTo('/my-payments');
  }

  connectedCallback() {
    super.connectedCallback();
    window.document.title = TITLES.ONLINE_BOOKING;

    setTimeout(() => {
      let localSession;

      try {
        localSession = JSON.parse(
          window.localStorage.getItem('neb-login-local'),
        );
      } catch (err) {
        // ignore
      }

      if (localSession) {
        store.dispatch(renewBookingSession(localSession));
      }
    });
  }

  async _stateChanged(state) {
    if (
      state.booking.tenantShortName &&
      state.booking.tenantShortName !== this.__tenantShortName
    ) {
      this.__tenantShortName = state.booking.tenantShortName;

      await store.dispatch(
        fetchOnlineBookingLazy({
          shortName: this.__tenantShortName,
        }),
      );

      await store.dispatch(fetchServices());
      await store.dispatch(fetchProviderAvailability());

      try {
        this.__practiceLogoSrc = await fetchPublic();
      } catch (e) {
        console.error(e);
      }
    }

    if (state.onlineBooking?.item?.selfCheckInMethod) {
      this.__selfCheckInMethod = state.onlineBooking.item.selfCheckInMethod;
    }

    if (state.onlineBooking && state.onlineBooking.item) {
      this.__selfCheckInInterval = state.onlineBooking.item.selfCheckInInterval;
      this.__selfCheckInRedirectDelay =
        state.onlineBooking.item.selfCheckInRedirectDelay;
    }

    if (
      state.onlineBooking &&
      state.onlineBooking.item &&
      state.onlineBooking.item.tenantId !== this.__tenantId
    ) {
      this.__tenantId = state.onlineBooking.item.tenantId;
    }

    if (state.apiOverride && state.apiOverride.value !== this.__apiPrefix) {
      this.__apiPrefix = state.apiOverride.value;
    }

    if (
      state.practiceInfo &&
      state.practiceInfo.practiceInfoItems &&
      state.practiceInfo.practiceInfoItems.length > 0 &&
      state.practiceInfo.practiceInfoItems[0] !== this.tenantPracticeInfo
    ) {
      this.tenantPracticeInfo = state.practiceInfo.practiceInfoItems[0];
      setRumTenant(this.tenantPracticeInfo);
    }

    if (state.route && state.route.hash) {
      this.__route = state.route.hash;
    }

    if (state.booking.user && state.booking.user !== this.__user) {
      this.__user = state.booking.user;

      setRumUser({
        ...this.__user,
        name: `${this.__user.firstName} ${this.__user.lastName}`,
      });

      this.__merchantAccount = await getOnlinePaymentMerchantAccount();

      if (this.__merchantAccount.id) {
        const { patient } = await fetchOnlinePatient();

        this.__linkedPatient = patient || {};
      } else {
        this.__linkedPatient = {};
      }

      if (this.__linkedPatient.patientId) {
        this.__showMyPayments = true;
      } else {
        this.__showMyPayments = false;
      }
    }

    if (
      !this.__fetchingPracticeInfo &&
      !this.tenantPracticeInfo.name &&
      this.__tenantShortName
    ) {
      this.__fetchingPracticeInfo = true;
      await store.dispatch(
        fetchPracticeInfo(REGISTRY_API_URL, this.__tenantShortName),
      );

      this.__fetchingPracticeInfo = false;
    }

    if (state.providers && state.providers.item.length) {
      this.__providers = state.providers.item;
    }

    if (state.popup && state.popup.main) {
      this.__numPopups = state.popup.main.length;

      if (this.__numPopups) {
        document.body.classList.add('no-scroll');
      } else {
        document.body.classList.remove('no-scroll');
      }
    }
  }

  __genNavItems() {
    const standardPages = [
      {
        exact: true,
        path: '/login',
        resolver: (_, { querystring }) => this.__renderLogin(querystring),
      },
      {
        exact: true,
        path: '/forgot-password',
        resolver: (_, { querystring }) =>
          this.__renderForgotPassword(querystring),
      },
      {
        exact: true,
        path: '/create-account',
        resolver: (_, { querystring }) =>
          this.__renderCreateAccount(querystring),
      },
      {
        exact: false,
        path: '/appointment/:id/',
        resolver: (tail, { params }) => html`
          <neb-booking-appointment-page
            id="${ELEMENTS.bookingAppointmentPage.id}"
            class="page"
            .appointmentId="${params.id}"
            .layout="${this.layout}"
            .apiPrefix="${this.__apiPrefix}"
            .tenantShortName="${this.__tenantShortName}"
            .tenantPracticeInfo="${this.tenantPracticeInfo}"
            .user="${this.__user}"
            .route="${tail}"
            .isReschedule="${true}"
            .onNavigateToLogin="${this.__handlers.navigateToLogin}"
            .enableBooking="${this.__enableBooking}"
          ></neb-booking-appointment-page>
        `,
      },
      {
        exact: false,
        path: '/walk-in-appointment/:id/',
        resolver: (tail, { params }) => html`
          <neb-booking-walk-in-appointment-page
            id="${ELEMENTS.bookingWalkInAppointmentPage.id}"
            class="page"
            .appointmentId="${params.id}"
            .layout="${this.layout}"
            .apiPrefix="${this.__apiPrefix}"
            .tenantShortName="${this.__tenantShortName}"
            .tenantPracticeInfo="${this.tenantPracticeInfo}"
            .user="${this.__user}"
            .route="${tail}"
            .isReschedule="${true}"
            .onNavigateToLogin="${this.__handlers.navigateToLogin}"
          ></neb-booking-walk-in-appointment-page>
        `,
      },
      {
        exact: true,
        path: '/my-appointments',
        resolver: () => html`
          <neb-my-appointments
            id="${ELEMENTS.myAppointments.id}"
            .providers="${this.__providers}"
            .locations="${this.tenantPracticeInfo.locations}"
            .layout="${this.layout}"
            .user="${this.__user}"
            .enableBooking="${this.__enableBooking}"
            .enableSelfCheckIn="${this.__enableSelfCheckIn}"
            .selfCheckInInterval="${this.__selfCheckInInterval}"
          ></neb-my-appointments>
        `,
      },
      {
        exact: true,
        path: '/my-payments',
        resolver: () => html`
          <neb-my-payments
            id="${ELEMENTS.myPayments.id}"
            .layout="${this.layout}"
            .practiceLogoSrc="${this.__practiceLogoSrc}"
            .practiceInfo="${this.tenantPracticeInfo}"
            .linkedPatient="${this.__linkedPatient}"
            .merchantAccount="${this.__merchantAccount}"
          ></neb-my-payments>
        `,
      },
    ];

    const checkInItems = [];

    let landingPage = {
      exact: false,
      path: '/',
      resolver: (tail, _) => html`
        <neb-booking-appointment-creator
          id="${ELEMENTS.bookingAppointmentCreator.id}"
          .apiPrefix="${this.__apiPrefix}"
          .layout="${this.layout}"
          .route="${tail}"
          .tenantShortName="${this.__tenantShortName}"
          .user="${this.__user}"
          .onLogout="${this.__handlers.resetOnLogout}"
        ></neb-booking-appointment-creator>
      `,
    };

    checkInItems.push(
      {
        exact: true,
        path: '/check-in',
        resolver: () => html`
          <neb-form-look-up-appointment
            id="${ELEMENTS.appointmentLookUpForm.id}"
            class="page"
            .layout="${this.layout}"
            .onLookUpAppointment="${this.__handlers
              .navigateToGuestAppointments}"
            .enableSelfCheckIn="${this.__enableSelfCheckIn}"
            .selfCheckInMethod="${this.__selfCheckInMethod}"
          ></neb-form-look-up-appointment>
        `,
      },
      {
        exact: true,
        path: '/guest-appointments',
        resolver: (
          _,
          { querystring: { firstName = '', lastName = '', dateOfBirth = '' } },
        ) => html`
          <neb-page-guest-appointments
            id="${ELEMENTS.guestAppointmentsPage.id}"
            .layout="${this.layout}"
            .model="${{
              firstName,
              lastName,
              dateOfBirth,
            }}"
            .enableBooking="${this.__enableBooking}"
            .selfCheckInPin="${this.__selfCheckInPin}"
            .selfCheckInInterval="${this.__selfCheckInInterval}"
            .selfCheckInRedirectDelay="${this.__selfCheckInRedirectDelay}"
            .onClearPin="${this.__handlers.clearPin}"
          ></neb-page-guest-appointments>
        `,
      },
      {
        exact: false,
        path: '/book-appointment',
        resolver: (tail, _) => html`
          <neb-booking-appointment-creator
            id="${ELEMENTS.bookingAppointmentCreator.id}"
            .apiPrefix="${this.__apiPrefix}"
            .layout="${this.layout}"
            .route="${tail}"
            .tenantShortName="${this.__tenantShortName}"
            .user="${this.__user}"
          ></neb-booking-appointment-creator>
        `,
      },
      {
        exact: false,
        path: '/walk-in',
        resolver: (tail, _) => html`
          <neb-booking-appointment-creator
            id="${ELEMENTS.walkInAppointmentCreator.id}"
            .apiPrefix="${this.__apiPrefix}"
            .layout="${this.layout}"
            .route="${tail}"
            .tenantShortName="${this.__tenantShortName}"
            .user="${this.__user}"
            .isWalkIn="${true}"
          ></neb-booking-appointment-creator>
        `,
      },
    );

    landingPage = {
      exact: true,
      path: '/',
      resolver: () => html`
        <neb-page-landing
          id="${ELEMENTS.landingPage.id}"
          class="page"
          .user="${this.__user}"
          .onNavigate="${this.__handlers.navigate}"
          .enableBooking="${this.__enableBooking}"
          .enableWalkIn="${this.__enableWalkIn}"
          .enableSelfCheckIn="${this.__enableSelfCheckIn}"
          .showMyPayments="${this.__showMyPayments}"
          .selfCheckInInterval="${this.__selfCheckInInterval}"
        ></neb-page-landing>
      `,
    };

    return [...checkInItems, ...standardPages, landingPage];
  }

  __computeVCardHref() {
    if (!this.__apiPrefix || !this.__tenantShortName) return '';

    return `${CORE_API_URL}/public/v1/${this.__tenantShortName}/downloadVCard`;
  }

  async __handleBookingInvite({
    bookingAccountInviteId,
    redirectFrom,
    redirectTo,
    route,
  }) {
    this.__redirectFrom = redirectFrom || '';

    if (!bookingAccountInviteId && this.__emailFromInvite) {
      this.__emailFromInvite = '';
      return;
    }

    if (this.__emailFromInvite || !this.__tenantId) return;

    const invite = await ([BOOKING_PAGES.CREATE_ACCOUNT].includes(redirectFrom)
      ? getBookingAccountInviteById(bookingAccountInviteId)
      : validateBookingAccountInvite(bookingAccountInviteId));

    if (
      route === BOOKING_PAGES.CREATE_ACCOUNT &&
      !invite &&
      bookingAccountInviteId
    ) {
      this.__navigateToLogin({
        bookingAccountInviteId,
        ...(redirectTo ? { redirectTo } : {}),
        redirectFrom: BOOKING_PAGES.CREATE_ACCOUNT,
      });

      return;
    }

    this.__emailFromInvite = invite?.email || '';
  }

  __renderCreateAccount({ bookingAccountInviteId, redirectTo }) {
    this.__handleBookingInvite({
      bookingAccountInviteId,
      redirectTo,
      route: BOOKING_PAGES.CREATE_ACCOUNT,
    });

    return html`
      <neb-page-create-account
        id="${ELEMENTS.createAccountPage.id}"
        class="page"
        .layout="${this.layout}"
        .bookingAccountInviteId="${bookingAccountInviteId}"
        .redirectTo="${redirectTo}"
        .emailFromInvite="${this.__emailFromInvite}"
      ></neb-page-create-account>
    `;
  }

  __renderLogin({ bookingAccountInviteId, redirectTo, redirectFrom }) {
    this.__handleBookingInvite({
      bookingAccountInviteId,
      redirectFrom,
      route: BOOKING_PAGES.LOGIN,
    });

    return html`
      <neb-booking-login-controller
        id="${ELEMENTS.loginController.id}"
        class="page login-change-password"
        .layout="${this.layout}"
        .onLogin="${this.__handlers.login}"
        .onForgotPassword="${this.__handlers.navigateToForgotPassword}"
        .onCreateAccount="${this.__handlers.navigateToCreateAccount}"
        .bookingAccountInviteId="${bookingAccountInviteId}"
        .redirectTo="${redirectTo}"
        .redirectFrom="${redirectFrom}"
        .emailFromInvite="${this.__emailFromInvite}"
      ></neb-booking-login-controller>
    `;
  }

  __renderForgotPassword({ bookingAccountInviteId, redirectTo, redirectFrom }) {
    this.__handleBookingInvite({
      bookingAccountInviteId,
      route: BOOKING_PAGES.FORGOT_PASSWORD,
    });

    return html`
      <neb-forgot-password
        id="${ELEMENTS.forgotPasswordForm.id}"
        class="page login-change-password"
        .onPasswordChanged="${this.__handlers.passwordChanged}"
        .onCancel="${this.__handlers.cancelForgotPassword}"
        .onPasswordResent="${this.__handlers.passwordResent}"
        .bookingAccountInviteId="${bookingAccountInviteId}"
        .redirectTo="${redirectTo}"
        .redirectFrom="${redirectFrom}"
        .emailFromInvite="${this.__emailFromInvite}"
      >
      </neb-forgot-password>
    `;
  }

  __renderForgotPasswordWithoutFF() {
    return html`
      <neb-forgot-password
        id="${ELEMENTS.forgotPasswordForm.id}"
        class="page login-change-password"
        .onPasswordChanged="${this.__handlers.passwordChanged}"
        .onCancel="${this.__handlers.cancelForgotPassword}"
        .onPasswordResent="${this.__handlers.passwordResent}"
      >
      </neb-forgot-password>
    `;
  }

  __reload() {
    window.location.reload();
  }

  async firstUpdated() {
    this.__elements = {
      timer: this.shadowRoot.getElementById('timer'),
    };

    await init();
  }

  __navigateTo(url, opts = {}) {
    const hasOpts = !!Object.keys(opts).length;
    const route = hasOpts
      ? `${url}?${new URLSearchParams(opts).toString()}`
      : url;
    const routeWithHash = `#${route}`;

    if (this.__route !== routeWithHash) {
      navigate(routeWithHash);
    }
  }

  update(changedProps) {
    if (changedProps.has('__route') && this.__numPopups) popPopup();

    this.__navItems = this.__genNavItems();

    if (changedProps.has('__user') && this.__user.id) {
      this.__elements.timer.startTimer();
    }

    super.update(changedProps);
  }

  async updated(changedProps) {
    if (changedProps.has('__tenantId') && this.__tenantId) {
      store.dispatch(fetchProviders(this.__tenantId));
    }

    if (changedProps.has('__tenantShortName') && this.__tenantShortName) {
      ({
        enableBooking: this.__enableBooking,
        enableWalkIn: this.__enableWalkIn,
        enableSelfCheckIn: this.__enableSelfCheckIn,
      } = await getBookingWalkInOverridesV2(store.getState()));
    }
  }

  __renderHeader() {
    return html`
      <div class="header">
        <div class="extra-spacing">
          <div class="tabs-container">
            <neb-tabs-old
              .onChange="${this.__handlers.tabChanged}"
              .selected="${this.selectedTab}"
            >
              <neb-tab-old id="${ELEMENTS.appointmentTab.id}" name="appointment"
                >Appointments</neb-tab-old
              >

              <neb-tab-old id="${ELEMENTS.aboutTab.id}" name="about"
                >About</neb-tab-old
              >
            </neb-tabs-old>
          </div>
        </div>

        <div id="tenantPracticeName" class="clinic-name">
          <span
            id="${ELEMENTS.tenantName.id}"
            class="tenant-name"
            @click="${this.__handlers.navigateToRoot}"
            >${this.tenantPracticeInfo.name}
          </span>
        </div>

        <neb-user
          id="${ELEMENTS.user.id}"
          class="user"
          .layout="${this.layout}"
          .userFirstName="${this.__user && this.__user.firstName
            ? this.__user.firstName
            : ''}"
          .onResetOnLogout="${this.__handlers.resetOnLogout}"
          .onNavigateToMyAppointments="${this.__handlers
            .navigateToMyAppointments}"
          .onNavigateToMyPayments="${this.__handlers.navigateToMyPayments}"
          .onNavigateToLogin="${this.__handlers.navigateToLogin}"
          .showMyPayments="${this.__showMyPayments}"
          @neb-create-account-user-menu="${this.__handlers
            .navigateToCreateAccount}"
        ></neb-user>
      </div>
    `;
  }

  __renderMainContainer() {
    return html`
      <div class="main-container">
        <div class="content-container">
          ${this.layout !== 'small' || this.selectedTab === 'appointment'
            ? html`
                <div
                  id="${ELEMENTS.contentPage.id}"
                  class="appointment-container"
                  selected-tab="${this.selectedTab}"
                >
                  ${matchRouteSwitch(
                    this.__navItems,
                    this.__route ? this.__route.replace('#', '') : '',
                  )}
                </div>
              `
            : ''}
          ${this.layout !== 'small' || this.selectedTab === 'about'
            ? html`
                <neb-page-practice-info
                  id="${ELEMENTS.practiceInfoPage.id}"
                  class="about-container page"
                  .logoSrc="${this.__practiceLogoSrc}"
                  .model="${this.tenantPracticeInfo}"
                  .vcardHref="${this.__computeVCardHref()}"
                  .layout="${this.layout}"
                  .tenantShortName="${this.__tenantShortName}"
                  .apiPrefix="${this.__apiPrefix}"
                  .enableBooking="${this.__enableBooking}"
                  .enableWalkIn="${this.__enableWalkIn}"
                ></neb-page-practice-info>
              `
            : ''}
        </div>
      </div>
    `;
  }

  __renderFooter() {
    return html`
      <div class="footer-container">
        <div class="footer-logo">
          <span>Created with</span>

          <neb-icon id="nebulaIcon" icon="neb:logo"></neb-icon>
        </div>
      </div>
    `;
  }

  render() {
    return html`
      ${this.__renderHeader()} ${this.__renderMainContainer()}
      ${this.__renderFooter()}

      <neb-global-loading-indicator
        id="${ELEMENTS.globalLoadingOverlay.id}"
        class="global-loading-overlay"
      ></neb-global-loading-indicator>

      <neb-banner-controller
        id="${ELEMENTS.bannerController.id}"
      ></neb-banner-controller>

      <neb-timeout
        @neb-timeout-end-session="${this.__handlers.resetOnLogout}"
        id="${ELEMENTS.timer.id}"
      ></neb-timeout>
    `;
  }
}
customElements.define('neb-booking-app', NebBookingApp);
